/**
 * 退出登录的类型
 */
export enum LogoutType {
  Other = 0,
  /** 登录人数超过限制强制退出登录 */
  OverLimit = 1,
  /** websocket 连接错误 */
  WSError = 2,
  /** 未登录或 token 失效去读取接口 */
  APIError = 3,
}
